import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "../components/ui";

import SignupNavbar from "../components/layout/SignupNavbar/SignupNavbar";

const SignupLayout = ({ children, noNavbar = false, noFooter = false }) => (
  <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
    <Row>
      <Col
        className="main-content p-0"
        lg={{ size: 12 }}
        md={{ size: 12 }}
        sm="12"
        tag="main"
      >
        <Col className="landing-top">
          {!noNavbar && <SignupNavbar />}
          <Row></Row>
        </Col>
        {children}
        {/**!noFooter && <MainFooter /> **/}
      </Col>
    </Row>
  </Container>
);

SignupLayout.propTypes = {
  noNavbar: PropTypes.bool,
  noFooter: PropTypes.bool,
};

export default SignupLayout;
